import { render, staticRenderFns } from "./examNotes.vue?vue&type=template&id=6ca5bcea&"
import script from "@viewJs/excuseExam/examNotes.js?vue&type=script&lang=js&"
export * from "@viewJs/excuseExam/examNotes.js?vue&type=script&lang=js&"
import style0 from "./examNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports